import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Composant qui annonce automatiquement les changements de page aux lecteurs d'écran
 */
export const LiveAnnouncer: React.FC = () => {
  const location = useLocation();
  const [announcement, setAnnouncement] = useState('');

  useEffect(() => {
    // Convertir le pathname en message compréhensible
    const path = location.pathname;
    let message = '';

    switch (path) {
      case '/dashboard':
        message = 'Vous êtes sur la page Tableau de bord';
        break;
      case '/caisse':
        message = 'Vous êtes sur la page Caisse';
        break;
      case '/analytics':
        message = 'Vous êtes sur la page Analyse des ventes';
        break;
      case '/retrait':
        message = 'Vous êtes sur la page Retrait';
        break;
      case '/retrait-analytics':
        message = 'Vous êtes sur la page Analyse des retraits';
        break;
      case '/statistics':
        message = 'Vous êtes sur la page Mes tableaux';
        break;
      case '/history':
        message = 'Vous êtes sur la page Historique';
        break;
      case '/team':
        message = 'Vous êtes sur la page Équipe';
        break;
      case '/export-import':
        message = 'Vous êtes sur la page Export/Import';
        break;
      case '/subscription':
        message = 'Vous êtes sur la page Abonnement';
        break;
      case '/settings':
        message = 'Vous êtes sur la page Paramètres';
        break;
      default:
        message = `Navigation vers ${path}`;
    }

    setAnnouncement(message);
  }, [location.pathname]);

  return (
    <div
      role="status"
      aria-live="polite"
      aria-atomic="true"
      className="sr-only"
    >
      {announcement}
    </div>
  );
};
